import React, { useState } from 'react';
import { Button, Input, Stack } from '@mui/material';
import "./image.css";
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "rgba(32, 38, 43, 0.95)",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgba(32, 38, 43, 0.95)",
    maxWidth: "7rem"
  },
}));

const input_styles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  width: "100%",
}

export default function TextField(props) {

  const handleCopy = () => {
    navigator.clipboard.writeText(props.text)
      .then()
      .catch()
  }

  return (
    <Stack direction="row" spacing={1.5} sx={input_styles}>
      <span className='TextField-header'>{props.name}</span>
      <BootstrapTooltip title={`${props.text}`} placement="right">
        <div className='TextField' >
          <div className='TextField-text'>{props.text}</div>
          <IconButton>
            <ContentCopyIcon
              sx={{
                fontSize: "0.875rem",
                cursor: "pointer",
                color: "rgb(255, 185, 64)",
                transform: "scaleX(-1)"
              }}
              onClick={handleCopy}
            />
          </IconButton>
        </div>
      </BootstrapTooltip>
    </Stack>
  );
}
